'use strict';

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

BreadcrumbsService=class BreadcrumbsService extends BaseService{
static get $inject(){
return['$state','$window','$timeout','userService','elementService','fatigueMeterTypeContentProviderService'];
}

constructor($state,$window,$timeout,userService,elementService,fatigueMeterTypeContentProviderService){
super();
this._$state=$state;
this._$window=$window;
this._$timeout=$timeout;
this._userService=userService;
this._elementService=elementService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;
this._crumbs=[];
}

startTrail(label){
this._crumbs.length=0;
this.dropCrumb(label);
}

dropCrumb(label){
let matchingIndex=_.findIndex(this._crumbs,crumb=>crumb.originalLabel===label);
if(matchingIndex!==-1){
this._crumbs.length=matchingIndex;
}

this._crumbs.push(this._createCrumb(label,this._$state.current.name));
this._updateWindowTitle(label);
}

updateLabelForState(newLabel,expectedState){
this._$timeout(()=>{
this._updateLabelForState(newLabel,expectedState);
});
}

_updateLabelForState(newLabel,expectedState){
_.ensureInstanceOf('string',newLabel);
_.ensureInstanceOf('string',expectedState);

const foundCrumb=_.findLast(this._crumbs,{stateName:expectedState});
if(!_.exists(foundCrumb)){
return;
}

foundCrumb.label=newLabel;
if(foundCrumb!==_.last(this._crumbs)){
return;
}

this._updateWindowTitle(newLabel);
}

clearCrumbsAndResetWindowTitle(){
this._crumbs=[];
this._updateWindowTitle(null);
}

_updateWindowTitle(label){
const newTitle=_.compact([label,this._fatigueMeterTypeContentProviderService.fullAppTitle]).join(' - ');

this._elementService.setText('head title',newTitle);
_.set(this._$window,'document.title',newTitle);

this._elementService.removeAttr('head title','data-ng-bind');
}

get crumbs(){
return this._crumbs;
}

_createCrumb(label,stateName){
return{
label,
stateName,
originalLabel:label,
follow:()=>this._$state.go(stateName)};

}};


module.exports=BreadcrumbsService;
//# sourceMappingURL=breadcrumbsService.js.map
